var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDesignIcons(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6786 8.99929C14.6786 12.8456 11.5606 15.9636 7.71429 15.9636C3.86802 15.9636 0.75 12.8456 0.75 8.99929C0.75 5.15302 3.86802 2.035 7.71429 2.035C11.5606 2.035 14.6786 5.15302 14.6786 8.99929Z",
    stroke: "white",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2499 8.99929C17.2499 12.8456 14.1318 15.9636 10.2856 15.9636C6.43931 15.9636 3.32129 12.8456 3.32129 8.99929C3.32129 5.15302 6.43931 2.035 10.2856 2.035C14.1318 2.035 17.2499 5.15302 17.2499 8.99929Z",
    stroke: "white",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesignIcons);
export default __webpack_public_path__ + "static/media/DesignIcons.afde3cd330681a98d1601cc4532249ce.svg";
export { ForwardRef as ReactComponent };